export default ({ types = [], proximity = "ip", limit = 5, language = "en", init, ...props }) => {
    return {
        search: "",
        options: [],
        ...props,
        getUrl(search) {
            const url = new URL(`https://api.mapbox.com/search/geocode/v6/forward`);

            url.search = new URLSearchParams({
                access_token: import.meta.env.VITE_MAPBOX_TOKEN,
                q: search,
                permanent: true,
                autocomplete: true,
                proximity: proximity,
                types: types,
                limit: limit,
                language: language,
            });

            return url;
        },
        getOptions(search) {
            return axios.get(this.getUrl(search)).then((response) => response.data.features);
        },
        async refreshOptions() {
            if (this.search.length > 2) {
                this.options = await this.getOptions(this.search);
            } else {
                this.options = [];
            }
        },
        init() {
            init?.bind(this)();
        },
    };
};
